(() => {
  'use strict';
  const initialized=new WeakSet();
  function setup(scope=document){
    const grids=[...(scope.matches?.('[data-sora-joy-grid]')?[scope]:[]),...scope.querySelectorAll('[data-sora-joy-grid]')];
    grids.forEach(grid=>{
      if(initialized.has(grid))return;
      initialized.add(grid);
      const cards=[...grid.querySelectorAll('[data-sora-mood]')];
      const buttons=[...grid.querySelectorAll('[data-sora-filter]')];
      const count=grid.querySelector('[data-sora-product-count]');
      function select(filter){
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.soraFilter===filter)));
        let visible=0;
        cards.forEach(card=>{card.hidden=filter!=='all'&&card.dataset.soraMood!==filter;if(!card.hidden)visible++;});
        if(count)count.textContent=visible+' little '+(visible===1?'find':'finds');
      }
      grid.addEventListener('click',event=>{const button=event.target.closest('[data-sora-filter]');if(button&&grid.contains(button))select(button.dataset.soraFilter);});
      select('all');
    });
  }
  setup();
  document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
